import styled from 'styled-components';

export const StyledTagSelector = styled.div`
  margin-bottom: 20px;
  position: relative;

  .label {
    display: block;
    color: #000;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 400;

    .required {
      color: red;
      font-size: 12px;
    }
  }

  .select-box {
    padding: 10px 20px;
    border-radius: 10px;
    border: 1px solid #dedede;
    background: #fbfbfb;
    cursor: pointer;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 40px;

    &.disabled {
      cursor: not-allowed;
    }

    .select-text {
      color: #999;

      &.selected {
        color: #333;
      }
    }

    .arrow-icon {
      display: block;
      width: 10px;
      height: 8px;
    }
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin-top: 4px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    max-height: 250px;
    overflow-y: auto;
  }

  .tag-item {
    padding: 10px 12px;
    cursor: pointer;
    background: #fff;
    color: #333;
    font-weight: 400;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.2s;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
      background: #f9f9f9;

      .tag-actions {
        opacity: 1;
      }
    }

    &.selected {
      background: #e8f1ff;
      color: #317bff;
      font-weight: 600;

      &:hover {
        background: #e8f1ff;
      }
    }

    .tag-name {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tag-actions {
      display: flex;
      gap: 8px;
      opacity: 0;
      transition: opacity 0.2s;

      .action-btn {
        background: transparent;
        border: none;
        padding: 4px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        transition: background 0.2s;

        &:hover {
          background: #efefef;
        }

        &.edit-btn {
          color: #317bff;
        }

        &.delete-btn {
          color: #ff4d4f;
        }

        svg {
          width: 14px;
          height: 14px;
        }
      }
    }

    .inline-edit-container {
      display: flex;
      gap: 6px;
      width: 100%;
      align-items: center;

      input {
        flex: 1;
        padding: 4px 8px;
        border: 1px solid #317bff;
        border-radius: 4px;
        font-size: 13px;
        outline: none;
      }

      .edit-actions {
        display: flex;
        gap: 4px;

        button {
          padding: 4px 8px;
          border-radius: 4px;
          font-size: 12px;
          cursor: pointer;
          border: 1px solid transparent;

          &.save-btn {
            background: #317bff;
            color: #fff;
          }

          &.cancel-btn {
            background: #fff;
            border-color: #ddd;
            color: #666;
          }
        }
      }
    }
  }

  .add-tag-button {
    padding: 10px 12px;
    cursor: pointer;
    background: #fff;
    color: #317bff;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 6px;
    border-top: 2px solid #f0f0f0;

    &:hover {
      background: #f9f9f9;
    }

    &.no-tags {
      padding: 12px;
      justify-content: center;
      text-align: center;
      border-top: none;
    }

    .plus-icon {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .tag-input-container {
    margin-top: 8px;
    padding: 12px;
    background: #f9f9f9;
    border-radius: 6px;
    border: 1px solid #e0e0e0;

    .input-group {
      display: flex;
      gap: 8px;

      input {
        flex: 1;
        padding: 8px 12px;
        border-radius: 6px;
        border: 1px solid #ddd;
        font-size: 14px;
        outline: none;
      }

      button {
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;

        &.add-button {
          border: none;
          background: #317bff;
          color: #fff;

          &:disabled {
            background: #ccc;
            cursor: not-allowed;
          }
        }

        &.cancel-button {
          border: 1px solid #ddd;
          background: #fff;
          color: #666;

          &:disabled {
            cursor: not-allowed;
          }
        }
      }
    }
  }

  &.alter-tag-container {
    margin-bottom: 0;
    padding: 0;

    .tag-name {
      font-size: 16px;
      color: #333;
      margin-bottom: 24px;
      white-space: normal;
      overflow: visible;
      text-overflow: clip;
      font-weight: 500;
    }

    .tag-actions {
      opacity: 1;
      justify-content: flex-end;
      gap: 12px;
      display: flex;

      .action-btn {
        padding: 10px 24px;
        font-size: 14px;
        font-weight: 500;
        min-width: 100px;
        border-radius: 8px;
        transition: all 0.2s;
        border: 1px solid transparent;

        &.cancel-btn {
          border-color: #ddd;
          color: #666;
          background: #fff;

          &:hover {
            background: #f5f5f5;
            border-color: #ccc;
          }
        }

        &.edit-btn {
          background: #317bff;
          color: #fff;

          &:hover {
            background: #2665d4;
          }
        }

        &.delete-btn {
          background: #ff4d4f;
          color: #fff;

          &:hover {
            background: #d9363e;
          }
        }
      }
    }
  }
`;
